/**
 * @file 小程序嗅探app列表
 * @author iknow-fe
 */

// 安卓列表
export const APP_PACKAGES_NAME = {
  'com.jingdong.app.mall': 2,
  'com.achievo.vipshop': 3,
  'com.taobao.taobao': 4,
  'com.suning.mobile.ebuy': 5,
  'ctrip.android.view': 6,
  'com.Qunar': 7,
  'com.sankuai.meituan': 8,
  'com.dianping.v1': 9,
  'com.homelink.android': 10,
  'com.xunmeng.pinduoduo': 11,
  'com.xingin.xhs': 12,
  'com.lianjia.beike': 13,
  'com.anjuke.android.app': 14,
  'com.fangdd.mobile.fddhouseownersell': 15,
  'com.wuba': 16,
  'com.baidu.haokan': 17,
  'com.cmcc.cmvideo': 18,
  'com.smile.gifmaker': 19,
  'com.p1.mobile.putong': 20,
  'com.taou.maimai': 21,
  'com.secoo': 22,
  'com.kaola': 23,
  'com.immomo.momo': 24,
  'com.uxin.usedcar': 25,
  'com.cubic.autohome': 26,
  'com.xcar.activity': 27,
  'com.alibaba.wireless': 28,
  'me.ele': 29,
  'com.baidu.minivideo': 30,
  'com.baidu.searchbox.lite': 31,
  'com.baidu.searchbox.mission': 32,
  'com.baidu.tieba': 33,
  'com.sina.weibo': 34,
  'com.baidu.searchbox': 35,
  'com.zhihu.android': 36,
  'com.qiyi.video': 37,
  'com.tencent.mm': 38,
  'com.comjia.kanjiaestate': 39,
  'com.qihoo.loan': 40,
  'com.tencent.weishi': 41,
  'com.duowan.mobile': 42,
  'com.tencent.tmgp.sgame': 43,
  'com.mfw.roadbook': 44,
  'com.tencent.tmgp.cf': 45,
  'com.taobao.trip': 46,
  'com.tencent.karaoke': 47,
  'com.baidu.hkvideo': 48,
  'com.ss.android.ugc.aweme': 49,
  'com.tencent.mtt': 50,
  'com.kmxs.reader': 51,
  'com.songwo.pig': 52,
  'tv.danmaku.bili': 53,
  'com.ss.android.article.video': 54,
  'com.jifen.qukan': 55,
  'com.lechuan.mdwz': 56,
  'me.yidui': 57,
  'com.yiche.autoeasy': 58,
  'com.kuaishou.nebula': 59,
  'com.eg.android.AlipayGphone': 60,
  'com.tentcent.news': 61,
  'com.tencent.qqlive': 62
};

// iOS列表
export const APP_SCHEMA_NAME = {
  'openapp.jdmobile://virtual': 2,
  'vipshop': 3,
  'tbopen://': 4,
  'suning://': 5,
  'ctrip://': 6,
  'qunariphone://': 7,
  'imeituan://': 8,
  'dianping://': 9,
  'lianjia://': 10,
  'pddopen://': 11,
  'xhsdiscover://': 12,
  'baiduhaokan://': 13,
  'bdminivideo://': 14,
  'baiduboxlite://': 15,
  'baiduboxmission://': 16,
  'com.baidu.tieba://': 17,
  'zhihu://': 18,
  'wireless1688://': 19,
  'iqiyi://': 20,
  'weixin://': 21,
  'qihooloan://360.cn': 22,
  'weishi://': 23,
  'travelguide://': 24,
  'wbmain://': 25,
  'taobaotravel://': 26,
  'kwai://': 27,
  'ksnebula://': 28,
  'sinaweibo://': 29,
  'alipays://': 30,
  'youku://': 31,
  'openjdlite://': 32,
  'com.360buy.jdpingou': 33,
  'cainiao://': 34,
  'kaola://': 35,
  'OneTravel://': 36,
  'lianjiabeike://': 37,
  'taobaolite://': 38,
  'eleme://': 39,
  'tomas://': 40,
  'secoo://': 41,
  'taoumaimai://': 42,
  'fleamarket://': 43,
  'taobaoliveshare://': 44,
  'amapuri://': 45,
  'openanjuke://': 46,
  'snssdk1128://': 47,
  'txvideo://': 48,
  'mttbrowser://': 49,
  'bilibili://': 50,
  'freereader://': 51,
  'tantanapp://': 52,
  'momochat://': 53,
  'tmall://': 54,
  'bosszp://': 55,
  'vmall://': 57,
  'yykiwi://': 58,
  'tuhu://': 59,
  'miguvideo://': 60,
  'comjia://': 61,
  'bitauto.yicheapp://': 62
};